import React, { ReactElement, FC } from 'react';
import styled from 'styled-components';
import { forTablet, forDesktop, forIE } from '@westwing/ui-kit/breakPoints';
import { useLooksTracking } from '../hooks/useLooksTracking';
import { useFilterState } from '../hooks/useFilterState';
import FilterAndSortBox from 'Client/components/Generic/FilterAndSortBox/FilterAndSortBox';
import useTranslator from 'Client/hooks/useTranslator';
import AppliedFiltersSlider from 'Client/components/Generic/AppliedFilters/AppliedFiltersSlider';
import { TrackLooksActions } from 'Common/ga/types';
import useRouter from 'Client/hooks/useRouter';

const StyledFiltersWrapper = styled.div`
    border-top: 1px solid ${({ theme }) => theme.colors.charcoal20};
    padding: 0 20px 0 30px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    ${forTablet`
        padding: 7px 0;
    `}
    ${forDesktop`
        flex-direction: column;
        padding: 0;
    `}
`;

const StyledFilterAndSortBox = styled(FilterAndSortBox)`
    width: 100%;
    ${forIE`
        flex-direction: row;
    `}
`;

export interface LooksFilterAndSortBoxProps {
    handleFiltersClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const LooksFilterAndSortBox: FC<LooksFilterAndSortBoxProps> = ({ handleFiltersClick }): ReactElement => {
    const {
        location: { pathname },
    } = useRouter();
    const t = useTranslator();
    const { LLP: LLPTracking } = useLooksTracking();
    const {
        appliedStyleFilter,
        appliedSliderFilters,
        styleFilter,
        onFilterValueChange,
        clearStylesFilter,
    } = useFilterState();

    const onExpandableFilterClick = () => LLPTracking.track(TrackLooksActions.LLPFilterClick, pathname);

    const onHandleFiltersClick = (event: React.MouseEvent<HTMLDivElement>) => {
        onExpandableFilterClick();
        LLPTracking.track(TrackLooksActions.LLPFilterOverlayImpression, pathname);
        handleFiltersClick(event);
    };

    return (
        <StyledFiltersWrapper>
            <StyledFilterAndSortBox
                filters={[styleFilter]}
                translator={t}
                appliedFilters={[appliedStyleFilter]}
                onFilterValueChange={onFilterValueChange}
                handleFiltersClick={onHandleFiltersClick}
                handleExpandableFilterClick={onExpandableFilterClick}
                preventShift
            />
            <AppliedFiltersSlider filters={appliedSliderFilters} removeFilterFunc={clearStylesFilter} />
        </StyledFiltersWrapper>
    );
};

export default LooksFilterAndSortBox;
